import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import type Locale from 'date-fns';

type Props = {
  selectedDate: Date;
  locale?: Locale
  onChange: (date: Date) => void;
}

const StaticDatePicker: React.FC<Props> = (props: Props) => {
  const { selectedDate, onChange, locale } = props;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
      <DatePicker
        variant="static"
        value={selectedDate}
        onChange={onChange}
      />
    </MuiPickersUtilsProvider>
  );
};

export default StaticDatePicker;
